var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
var LOGIN_ERROR_STRINGS = appStrings.modules.login.error.login;
var headersWithGuestToken = function (guestToken) {
    var headers = { 'Content-Type': 'application/json' };
    if (guestToken)
        headers.Authorization = "Bearer ".concat(guestToken);
    return headers;
};
export function handleEmailLogin(email, password, environmentUrl, guestToken) {
    return fetch("".concat(environmentUrl, "/users/login"), {
        method: 'POST',
        headers: headersWithGuestToken(guestToken),
        body: JSON.stringify({ email: email, password: password }),
    });
}
export function handlePhoneLogin(phone, environmentUrl) {
    return fetch("".concat(environmentUrl, "/otp/send-code"), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phone: phone }),
    });
}
export function handleOtpVerify(code, phone, environmentUrl, guestToken) {
    return fetch("".concat(environmentUrl, "/otp/login"), {
        method: 'POST',
        headers: headersWithGuestToken(guestToken),
        body: JSON.stringify({ code: code, phone: phone }),
    });
}
export function handleBasicRegistration(payload, environmentUrl, guestToken) {
    return fetch("".concat(environmentUrl, "/users/register"), {
        method: 'POST',
        headers: headersWithGuestToken(guestToken),
        body: JSON.stringify(__assign(__assign({}, payload), { accepted_terms: true })),
    });
}
export function handleBasicRegistrationWithError(payload, environmentUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var response, errorBody, responseJson;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch("".concat(environmentUrl, "/users/register"), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(__assign(__assign({}, payload), { accepted_terms: true })),
                    })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3, 3];
                    return [4, response.json()];
                case 2:
                    errorBody = _a.sent();
                    throw {
                        status: response.status,
                        response: errorBody,
                    };
                case 3: return [4, response.json()];
                case 4:
                    responseJson = _a.sent();
                    return [2, {
                            status: response.status,
                            token: responseJson.token,
                            user: responseJson.user,
                        }];
            }
        });
    });
}
export function sendPasswordReset(email, environmentUrl, source) {
    return fetch("".concat(environmentUrl, "/users/send-password-reset-email"), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email, source: source }),
    });
}
export function resetPassword(password, confirmPassword, token, environmentUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var decodedToken, response, errorBody, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    decodedToken = decodeURIComponent(token);
                    return [4, fetch("".concat(environmentUrl, "/users/reset-password"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(decodedToken),
                            },
                            body: JSON.stringify({ password: password, confirmPassword: confirmPassword }),
                        })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3, 3];
                    return [4, response.json().catch(function () { return ({}); })];
                case 2:
                    errorBody = _a.sent();
                    error = {
                        status: response.status,
                        response: errorBody,
                    };
                    throw error;
                case 3: return [2];
            }
        });
    });
}
export function verifyTempToken(token, environmentUrl) {
    var decodedToken = decodeURIComponent(token);
    return fetch("".concat(environmentUrl, "/users/crossdomain"), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: "Bearer ".concat(decodedToken),
        },
    });
}
export var decodeToken = function (tok) {
    var base64Url = tok.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window
        .atob(base64)
        .split('')
        .map(function (c) { return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2)); })
        .join(''));
    return JSON.parse(jsonPayload);
};
export var getTokenExpirationDate = function (tok) { return new Date(decodeToken(tok).exp * 1000); };
export var ENVIRONMENTS = {
    local: 'local',
    dev: 'development',
    staging: 'staging',
    stg: 'stg',
    prod: 'production',
    prd: 'prd',
};
export var computeEnvironment = function (environment) {
    var env = environment || ENVIRONMENTS.local;
    return env;
};
export function handleAutoLogin(access_token, environmentUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var response, jsonUser, user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch("".concat(environmentUrl, "/users/auto-login"), {
                        method: 'PUT',
                        headers: {
                            Authorization: "Bearer ".concat(access_token),
                            'Content-Type': 'application/json',
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3, 3];
                    return [4, response.json()];
                case 2:
                    jsonUser = _a.sent();
                    user = __assign(__assign({}, jsonUser), { access_token: access_token, birthday: jsonUser.birthday
                            ? new Date(jsonUser.birthday).toISOString().split('T')[0]
                            : undefined });
                    return [2, user];
                case 3: return [2, null];
            }
        });
    });
}
export var handleLoggingIn = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var res, _c, loginResponse, loginObject, _d;
    var phone = _b.phone, email = _b.email, password = _b.password, environmentUrl = _b.environmentUrl, afterLogin = _b.afterLogin, setErrorMessage = _b.setErrorMessage, guestToken = _b.guestToken;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!phone) return [3, 2];
                return [4, handlePhoneLogin(phone, environmentUrl)];
            case 1:
                _c = _e.sent();
                return [3, 4];
            case 2: return [4, handleEmailLogin(email, password, environmentUrl, guestToken)];
            case 3:
                _c = _e.sent();
                _e.label = 4;
            case 4:
                res = _c;
                if (!res.ok) {
                    if (res.status === 503) {
                        setErrorMessage('Service is currently unavailable. Please try again later.');
                    }
                    setErrorMessage(phone ? LOGIN_ERROR_STRINGS.phone : LOGIN_ERROR_STRINGS.userNameOrPassword);
                    return [2];
                }
                return [4, res.json()];
            case 5:
                loginResponse = _e.sent();
                loginObject = !phone ? loginResponse : __assign(__assign({}, loginResponse), { phone: phone });
                _d = afterLogin;
                if (!_d) return [3, 7];
                return [4, afterLogin(loginObject)];
            case 6:
                _d = (_e.sent());
                _e.label = 7;
            case 7: return [2, _d];
        }
    });
}); };
export var handleUserRegistration = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var res;
    var payload = _b.payload, environmentUrl = _b.environmentUrl, afterRegistration = _b.afterRegistration, setErrorMessage = _b.setErrorMessage, guestToken = _b.guestToken;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, handleBasicRegistration(payload, environmentUrl, guestToken)];
            case 1:
                res = _c.sent();
                if (!res.ok) {
                    setErrorMessage('Error registering user');
                    return [2];
                }
                return [2, afterRegistration && afterRegistration()];
        }
    });
}); };
function computeDomain(hostname) {
    var parts = hostname.split('.');
    var len = parts.length;
    if (len >= 2 && parts[len - 2] === 'backrs' && parts[len - 1] === 'com') {
        if (len >= 3 && parts[len - 3] === 'sandbox') {
            return '.sandbox.backrs.com';
        }
        return '.backrs.com';
    }
    if (len >= 3 && parts[len - 2] === 'backrs-dev' && parts[len - 1] === 'com') {
        var subDomain = parts[len - 3];
        if (['dev', 'staging', 'stg', 'prd', 'sandbox'].includes(subDomain)) {
            return ".".concat(subDomain, ".backrs-dev.com");
        }
    }
    return '.app.localhost';
}
var ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;
export var setCookie = function (token, environment) {
    var env = computeEnvironment(environment);
    var exp = decodeToken(token).exp;
    var expirationDate = exp ? new Date(exp * 1000) : new Date(Date.now() + ONE_YEAR_MS);
    var secureTag = env !== 'local' ? '; secure' : '';
    document.cookie = "token=".concat(encodeURIComponent(token), "; domain=").concat(computeDomain(window.location.hostname), "; path=/; expires=").concat(expirationDate.toUTCString()).concat(secureTag);
};
export var getCookie = function () {
    var cookie = document.cookie.split('; ').find(function (row) { return row.startsWith('token='); });
    if (!cookie) {
        return null;
    }
    var value = cookie.split('=')[1];
    return decodeURIComponent(value);
};
export var removeCookie = function () {
    document.cookie = "token=; path=/; domain=".concat(computeDomain(window.location.hostname), "; expires=Thu, 01 Jan 1970 00:00:01 GMT;");
};
export var getAccessToken = function (tokenType) {
    var accessToken = localStorage.getItem(tokenType);
    if (!accessToken) {
        return null;
    }
    return accessToken;
};
export var setAccessToken = function (tokenType, token) {
    localStorage.setItem(tokenType, token);
};
export var deleteAccessToken = function (tokenType) {
    localStorage.removeItem(tokenType);
};
export var getAccessTokenOrCookie = function (tokenType, isUnifiedLoginDisabled) {
    if (isUnifiedLoginDisabled === void 0) { isUnifiedLoginDisabled = false; }
    var cookie = getCookie();
    if (!cookie && !isUnifiedLoginDisabled) {
        return null;
    }
    return getAccessToken(tokenType) || cookie;
};
